import React from 'react';

const LOGOS=[
  {src: '/assets/brand/logo-ammdk.webp',alt: 'Asociación Mexicana de Moo Duk Kwan',label: 'AMMDK'},
  {src: '/assets/brand/logo-inteq.webp',alt: 'INTEQ Integración y Equilibrio',label: 'INTEQ'},
];

// Logos de AMMDK e INTEQ; se muestran en el footer y debajo del login.
export default function AssociationLogos({className=''}) {
  return (
    <div className={`flex flex-col sm:flex-row items-center justify-center gap-8 md:gap-12 ${className}`}>
      {LOGOS.map((logo,index)=> (
        <React.Fragment key={logo.label}>
          {index>0 && <div className="hidden sm:block h-24 w-px bg-white/15" />}
          <div className="flex flex-col items-center gap-3">
            <div className="h-28 w-28 md:h-32 md:w-32 rounded-3xl bg-white/95 p-2 shadow-xl">
              <img src={logo.src} alt={logo.alt} className="h-full w-full object-contain" />
            </div>
            <span className="text-[9px] font-black uppercase tracking-[0.25em] text-white/60">
              {logo.label}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
